import { useRouter } from 'next/router'
import { useMemo } from 'react'
import {
  IoLink,
  IoLogoFacebook,
  IoLogoLinkedin,
  IoLogoTwitter
} from 'react-icons/io5'

import { NotificationType, notify } from 'src/providers/NotificationProvider'

import { IconButton } from 'src/components/atoms/IconButton'

import { env } from 'src/env/client.mjs'

export const ShareActions = () => {
  const { asPath: path } = useRouter()

  const pageUrl = useMemo(() => `${env.NEXT_PUBLIC_APP_DOMAIN}${path}`, [path])

  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php/?u=${pageUrl}`
  const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`
  const twitterShareUrl = `https://www.twitter.com/share/?url=${pageUrl}&via=TreesThatCount`

  const handleClick = (shareUrl: string) => () => {
    window.open(shareUrl, 'share-dialog', 'width=600,height=600')
  }

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(pageUrl)
    notify({ type: NotificationType.info, message: 'Link copied to clipboard' })
  }

  return (
    <div>
      <IconButton
        icon={IoLogoFacebook}
        ariaLabel='Share to Facebook'
        onClick={handleClick(facebookShareUrl)}
      />
      <IconButton
        icon={IoLogoLinkedin}
        ariaLabel='Share to LinkedIn'
        onClick={handleClick(linkedInShareUrl)}
      />
      <IconButton
        icon={IoLogoTwitter}
        ariaLabel='Share to Twitter'
        onClick={handleClick(twitterShareUrl)}
      />
      <IconButton
        icon={IoLink}
        ariaLabel='Copy link'
        onClick={handleCopyToClipboard}
      />
    </div>
  )
}
